<template>
  <div class="blog">
    <div class="container background-container">
      <div class="row">
        <div class="col-md-12 p-0 pt-4">
          <img
            class="blog__header-image"
            src="@/assets/images/blog/bestsocialmediaplatforms/header.jpg"
            alt="header-image"
          />
        </div>
      </div>
    </div>

    <div class="container p-md-0">
      <div class="row">
        <div class="col-md-12 p-md-0">
          <h1 class="blog__title">
            Found - How to decide which social media platform is best for you.
          </h1>
        </div>
      </div>

      <div class="row position-relative">
        <div
          v-if="userAgent && !isInstagramBrowser"
          class="blog__social d-md-flex d-none"
        >
          <span class="blog__social-title">Share</span>
          <div
            v-for="(link, key) in socialLinks"
            :key="key"
            class="mt-2"
            @click="handleShareClick"
          >
            <img :src="getImageItem(key)" :alt="key" />
          </div>
        </div>
        <div class="col-md-8 offset-md-2">
          <p>
            You’ve seen the potential success that you can have by creating
            content and building an audience – and how then engaging with Found
            can help you turn that content into cold, hard cash.
          </p>
          <p>
            But if you’re at the beginning of your journey and are just starting
            out, it can be challenging to decide what platforms you should
            engage with.
          </p>
          <p>
            One of the goals that you need to set yourself is to grow your
            audience – and that should help inform all the decision you make.
          </p>
          <p>
            More than half of consumers these days learn about new brands via
            social media, which has the power to create a direct line of
            communication between customers and that brand.
          </p>
          <p>
            It’s also an invaluable source of information – you can check out
            the kind of posts that do well and the way that other
            companies/influencers respond.
          </p>
          <p>
            Looking at the success of other people who operate in the area
            you’re interested in can really help you make informed decisions.
          </p>
          <p>
            The good news is that you don’t have to choose just one platform to
            operate on – in fact the more you use, the bigger your potential
            audience!
          </p>
          <p>
            If you’re not sure about the pros and cons, here’s our no-nonsense
            guide to social media.
          </p>

          <img
            class="blog__landscape-image"
            src="@/assets/images/blog/bestsocialmediaplatforms/1.jpg"
            alt="image"
          />

          <h2>TikTok</h2>

          <p>
            Feel free to come and find us here
            <a href="https://www.tiktok.com/@becomefound" target="_blank"
              >www.tiktok.com/@becomefound</a
            >
          </p>
          <p>
            There’s no doubt that TikTok is the platform “de jour” – the most
            downloaded app in 2020 and the popular website in 2021.
          </p>
          <p>
            It uses short form videos, where those which are entertaining or
            funny definitely have the largest levels of engagement, but it
            covers every conceivable topic – from cooking to DIY.
          </p>
          <p>
            It does cater for quite a young demographic – mostly teenagers
            through to 24-year-olds, although it’s popularity among older age
            groups is definitely growing.
          </p>
          <p>
            TikTok is a fantastic way for creators and their audience to
            interact and its unique algorithm help watchers find the videos for
            the subjects they interested in – which means that anyone wanting
            recipes or keen on cooking can be directed to possible areas of
            interest.
          </p>
          <p>
            To be successful on TikTok – after all everyone’s ambition is to go
            viral – there’s a few tips that can help. Make sure you come over as
            your authentic self and highlight your uniqueness.
          </p>
          <p>
            While there’s no magic formula for TikTok success, operating in a
            particular area such as cooking videos are always up there with the
            most popular areas – so that’s a very good start.
          </p>
          <p>
            It’s certainly not impossible – for example take a look at one of
            Found’s success stories, Matthew Bounds. Matthew posts under his
            account @yourbarefootneighbour and suddenly found his twist on a
            traditional American cobbler not only got him 24 million views but
            led to an appearance on Good Morning America.
          </p>
          <p>
            This is the power of TikTok, so it’s worth putting in the time and
            effort to create an account.
          </p>
          <p>
            If you’re unsure about creating videos, there’s some great tutorials
            and advice on the web which can help you and build your confidence.
          </p>

          <img
            class="blog__landscape-image"
            src="@/assets/images/blog/bestsocialmediaplatforms/2.jpg"
            alt="image"
          />

          <h2>Instagram</h2>
          <p>
            Found account:
            <a href="https://www.instagram.com/becomefound/" target="_blank">
              www.instagram.com/becomefound/
            </a>
          </p>
          <p>
            If you’ve got TikTok, then you definitely need to sign up for the
            social media giant that is Instagram. With a mind boggling two
            billion users worldwide, you can use the platform to promote posts,
            offers, stories, reels, and live streams.
          </p>
          <p>
            This is also a great way to push your brand and your merchandise,
            with a shopping feature where you can include links to your
            products.
          </p>
          <p>
            Instagram has the advantage of being something that it’s quick to
            post on and doesn’t require quite as much effort as making a video
            for TikTok – although you can of course include that on Instagram
            too!
          </p>
          <p>
            Instagram stories and Instagram live streams are a great way to
            introduce the personal sides of your business. You could feature new
            creators doing takeovers, offer Q&A’s, host polls about what your
            audience wants to see.
          </p>
          <p>
            The photo-first format places a visual focus, great for releasing
            new book covers or appealing food photos which tease new releases.
          </p>
          <p>
            Instagram offers in-house advertising, where adverts can be directed
            at specific demographics to make sure your adverts are the most
            effective – a great way to promote your cookery books and
            merchandise!
          </p>
          <p>
            Plus, their ‘insights’ suite for businesses also allows you to
            analyse which posts do best, which customers engage the most, what
            kind of customers you have and recognise trends in your content.
          </p>

          <img
            class="blog__landscape-image"
            src="@/assets/images/blog/bestsocialmediaplatforms/3.jpg"
            alt="image"
          />

          <h2>Facebook</h2>

          <p>
            Found Account: www.facebook.com/becomefound/

            <a href="https://www.facebook.com/becomefound/" target="_blank">
              www.facebook.com/becomefound/
            </a>
          </p>
          <p>
            The grandaddy of them all, Facebook is probably the most recognised
            social media site and is the perfect choice if you want to engage
            with a slightly older demographic.
          </p>
          <p>
            Facebook also has its own shopping service, and you can use its
            business suite in tandem with Instagram, so you can double up
            content and synchronise your posts. It also offers a scheduling tool
            for posts which takes the pressure off coordinating and uploading
            posts every day, especially on times like the weekend or holidays.
          </p>
          <p>
            Facebook offers some functions such as events which can then be
            suggested to your audience. Could be good for virtual book launches,
            upcoming Q&A’s or even in-person events that you might want
            audiences to attend.
          </p>
          <p>
            It’s also the platform with the broadest set of tools, where people
            can like your entire business and share it on their page. You can
            create communities, groups, and events and post job listings. It
            might not be as slick or as simple as newer platforms like Instagram
            or TikTok, but it is the most established and offers the most
            features – and with almost three billion users it definitely can’t
            be ignored!
          </p>

          <h2>Twitter</h2>

          <p>
            Found Account: :

            <a href="https://twitter.com/becomefound" target="_blank">
              twitter.com/becomefound
            </a>
          </p>
          <p>
            Twitter may not be as useful as some of the other platforms, but it
            still pays to have it in your arsenal.
          </p>
          <p>
            It’s great for teaser campaigns and because of its direct message
            facility, it’s easy to engage with potential customers. With 238m
            daily users, of which more than 50% check their feed every day, this
            is a great way to engage and promote your brand.
          </p>
          <p>
            It’s a brilliant platform to showcase your book, your recipes and
            your merchandise and definitely needs to be part of your marketing
            plans.
          </p>
          <p>
            If you’re short of time and images then that’s not a problem, use
            Twitter to answer questions or share news.
          </p>
          <p>
            And you can also use features such as polls to directly engage with
            potential audiences.
          </p>
          <br />
          <p>And finally….</p>
          <p>
            There’s no denying that posting on all of the social media platforms
            can be a massive commitment, but the potential rewards are there for
            all to see!
          </p>
          <p>
            If you don’t have the time to constantly be posting to every
            platform, then look at the one that you feel will best represent you
            and make that the focus of your efforts.
          </p>
          <p>
            There are certain apps that you can programme to share your content
            on a number of platforms at any one time so that might also be worth
            some investigating.
          </p>
          <p>
            Do your homework and then you can look forward to rich pickings!
          </p>

          <div
            v-if="userAgent && !isInstagramBrowser"
            class="blog__social d-md-none"
          >
            <span class="blog__social-title">Share</span>
            <div class="d-flex">
              <div
                v-for="(link, key) in socialLinks"
                :key="key"
                class="mt-2 mr-md-0 mr-3"
                @click="handleShareClick"
              >
                <img :src="getImageItem(key)" :alt="key" />
              </div>
            </div>
          </div>

          <div v-if="tags && tags.length">
            <h2 class="mt-4">Related topics</h2>
            <div class="blog__tags">
              <Tag
                v-for="tag in tags"
                :key="tag"
                class="mr-3 my-2"
                @click="onTagClick(tag)"
              >
                {{ tag }}
              </Tag>
            </div>
          </div>

          <div class="blog__action-button mt-5">
            <Button
              class="pt-2"
              full-width
              size="sm"
              @click="handleBeFoundClick"
            >
              I’m ready to talk
            </Button>
          </div>

          <Carousel
            v-if="creatorProducts && creatorProducts.length"
            id="blog-products"
            class="my-4"
            :items="creatorProducts"
            :mode="CarouselModes.PRODUCT"
            show-default-item-actions
            @click="handleProductBundleClick"
          >
            <template #title>
              <h2>More from {{ creatorHandle }}</h2>
            </template>
          </Carousel>

          <div class="blog__action-button mt-3 mb-5">
            <Button
              class="pt-2"
              full-width
              size="sm"
              variant="outline"
              @click="$router.push('/blog')"
            >
              View all blogs
            </Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { throttle } from 'lodash';
import socialLinks from '@/misc/socialLinks';
import { CarouselModes, WebApiCancelError } from '@/misc/constants';
import Tag from '@/components/Elements/Tag.vue';
import Button from '@/components/Elements/Button.vue';
import getDefaultProductFormat from '@/misc/getDefaultProductFormat';
import formatMoney from '@/misc/formatMoney';
import getFormatPrice from '@/misc/getFormatPrice';
import { fetchProductsByCreator } from '@/services/products';
import filterProductsByRegion from '@/misc/filterProductByRegion';

export default {
  name: 'BlogItemPage',
  components: {
    Button,
    Tag,
    Carousel: () =>
      import(/* webpackPrefetch: true */ '@/components/Carousel/Index')
  },

  data() {
    return {
      creatorHandle: 'yourbarefootneighbor',
      CarouselModes,
      socialLinks,
      creatorProducts: [],
      tags: ['General']
    };
  },

  head: {
    title: 'Be Found | Blog'
  },

  computed: {
    ...mapState('main', ['userAgent']),
    ...mapGetters({
      isInstagramBrowser: 'main/isInstagramBrowser',
      currency: 'config/currency',
      region: 'config/region'
    })
  },

  mounted() {
    fetchProductsByCreator(this.$axios, this.creatorHandle)
      .then((response) => {
        const creatorProducts = this.$get(response, 'creatorProducts');
        this.creatorProducts = filterProductsByRegion(
          creatorProducts,
          this.region
        );
        this.contributedProducts = filterProductsByRegion(
          this.$get(response, 'contributedProducts'),
          this.region
        );
      })
      .catch((err) => {
        this.$showToastMessage(
          this.$get(err, 'response.data.message'),
          'Error',
          'danger'
        );
      });
  },

  methods: {
    getImageItem(key) {
      return require(`@/assets/icons/social/${key}.svg`);
    },

    onTagClick(tag) {
      this.$router.push('/blog?filter=' + tag);
    },

    handleBeFoundClick() {
      this.$router.push({ path: '/be-found' });
    },

    handleShareClick: throttle(function () {
      const url = window.location.href;
      if (navigator?.share) {
        navigator.share({ url }).catch((err) => {
          if (!err.message.includes(WebApiCancelError)) {
            this.$showToastMessage(err.message, 'Error', 'error');
          }
        });
      } else if (navigator?.clipboard) {
        navigator.clipboard
          .writeText(url)
          .then(() =>
            this.$showToastMessage('Link is copied', 'Success', 'success')
          )
          .catch((err) =>
            this.$showToastMessage(
              `Failed to copied link ${err.message}`,
              'Error',
              'error'
            )
          );
      } else {
        this.$showToastMessage(
          `Sharing function is not supported`,
          'Error',
          'error'
        );
      }
    }, 1500),

    getProductFormatPrice(product) {
      const defaultFormat = getDefaultProductFormat(product);
      return formatMoney(
        getFormatPrice(defaultFormat, this.region)?.amount,
        this.currency
      );
    },

    handleProductBundleClick(product) {
      this.$router.push({
        path: `/products/${product.id || product.item.id}`
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.blog {
  &__header-image {
    object-fit: cover;
    height: 480px;
    width: 100%;
  }

  &__title {
    padding-top: 40px;
    text-align: left;
    line-height: 56px;
  }

  &__landscape-image {
    object-fit: contain;
    height: 550px;
    width: 100%;
    margin-bottom: 40px;
  }

  &__social {
    position: absolute;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    text-align: center;

    &-title {
      font-size: 12px;
    }
  }

  &__double-image {
    display: flex;
    justify-content: space-around;

    img {
      object-fit: cover;
      height: 700px;
      &:first-child {
        margin-right: 20px;
      }
    }
  }

  &__quote {
    font-family: 'Poppins-SemiBold', sans-serif;
    font-size: 24px;
    border-left: 8px solid $primary-color;
    padding-left: 35px;
  }

  &__action-button {
    margin: 0 auto;
    max-width: 240px;
  }

  @media (max-width: $screen-width-md) {
    &__header-image {
      object-fit: contain;
      height: 242px;
    }

    &__landscape-image {
      height: 328px;
    }

    &__double-image {
      flex-wrap: wrap;

      img {
        margin-bottom: 25px;
        object-fit: cover;
        height: 420px;
        &:first-child {
          margin-right: 0;
        }
      }
    }

    &__social {
      position: initial;
      flex-direction: column;
      text-align: left;
    }
  }
}
</style>
